import cookie from 'js-cookie';

const setCookie = (
  key,
  value,
  expires = 3024000,
  subDomain = false,
  iframe = false
) => {
  if (process.browser) {
    const thirdPartyParam = iframe
      ? {
          sameSite: 'None',
          secure: true
        }
      : {};
    if (subDomain) {
      cookie.set(key, value, {
        expires,
        path: '/',
        ...thirdPartyParam
      });
      if (key === 'accessToken') {
        cookie.set('loggedIn', true, {
          expires,
          path: '/',
          ...thirdPartyParam
        });
      }
    } else {
      cookie.set(key, value, {
        expires,
        path: '/',
        ...thirdPartyParam
      });
    }
  }
};

const eraseCookie = (key) => {
  if (process.browser) {
    cookie.remove(key);
    if (key === 'accessToken') {
      cookie.remove('loggedIn');
    }

    if (key === 'accessToken' || key === 'loggedIn') {
      cookie.remove('accessToken', {
        path: '/'
      });
      cookie.remove('accessToken', {
        path: '/'
      });
      cookie.remove('loggedIn', {
        path: '/'
      });
    }
  }
};

const deleteSubdomainCookies = () => {
  if (process.browser) {
    cookie.remove('accessToken', {
      path: '/',
      domain: '.unacademy.com'
    });
    cookie.remove('refreshToken', {
      path: '/',
      domain: '.unacademy.com'
    });
    cookie.remove('loggedIn', {
      path: '/',
      domain: '.unacademy.com'
    });
  }
};

const getCookieFromBrowser = (key) => cookie.get(key);

const getCookieFromServer = (key, state) => state().auth[key];

const readCookie = (key, state) =>
  state ? getCookieFromServer(key, state) : getCookieFromBrowser(key);

export default {
  setCookie,
  readCookie,
  eraseCookie,
  deleteSubdomainCookies
};
